/* eslint-disable jsx-a11y/label-has-associated-control */
import ReactDatePicker from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import moment from 'moment';
import { IDatePickerLayout, IDatePickerRangeLayout } from '../../types/layout/datepicker';
import { IFormItemProps } from '../../types/components/form';
import { formats } from '../../constants/formats';
import { getFormItemClassName } from '../../helpers/form';

type TDateRangePickerValue = [Date | null, Date | null];

export type TDatePickerValue = Date | TDateRangePickerValue | null;

type TDatePickerProps = (IDatePickerLayout | IDatePickerRangeLayout) & IFormItemProps;

function DatePicker({
    disabled, type, onChange, placeholder, value, additionalClassName,
}: TDatePickerProps) {
    const getValueDate = (v: string | null) => (typeof v === 'string' ? moment(v).toDate() : null);

    const getValue = (): TDateRangePickerValue => {
        if (Array.isArray(value)) {
            return [getValueDate(value[0]), getValueDate(value[1])];
        }
        if (typeof value === 'string') {
            return [getValueDate(value), null];
        }
        return [null, null];
    };

    const [startDate, endDate] = getValue();

    const onChangeHandler = (date: Date | TDatePickerValue | null) => {
        let formValue = null;
        switch (type) {
            case 'datepicker': {
                if (date instanceof Date) {
                    formValue = moment(date).format(formats.date);
                }
                break;
            }
            case 'datepicker-range': {
                if (Array.isArray(date)) {
                    formValue = [
                        date[0] instanceof Date ? moment(date[0]).format(formats.date) : null,
                        date[1] instanceof Date ? moment(date[1]).format(formats.date) : null,
                    ];
                }
                break;
            }
        }
        onChange(formValue);
    };

    return (
        <ReactDatePicker
            disabled={disabled}
            className={getFormItemClassName('form-control', additionalClassName)}
            selectsRange={type === 'datepicker-range'}
            isClearable={!disabled}
            selected={type === 'datepicker' ? startDate : undefined}
            startDate={type === 'datepicker-range' ? startDate : undefined}
            endDate={type === 'datepicker-range' ? endDate : undefined}
            onChange={onChangeHandler}
            placeholderText={placeholder}
            locale={ru}
            dateFormat="dd.MM.yyyy"
        />
    );
}

DatePicker.defaultProps = {
    breakpointColumn: undefined,
};

export default DatePicker;
